import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TOSS_PIXEL_CODE = "3197511697500323645";

export const useTossPixelPageView = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.TossPixel) {
      new window.TossPixel(TOSS_PIXEL_CODE).pageView();
    }
  }, [location]);
};

export const useTossPixelProductView = (productData) => {
  useEffect(() => {
    if (window.TossPixel && productData) {
      new window.TossPixel(TOSS_PIXEL_CODE).productView(productData);
    }
  }, [productData]);
};

// 리드 수집 훅 - 함수 반환
export const useTossPixelLead = () => {
  const trackLead = (leadType = "Consultation") => {
    if (window.TossPixel) {
      new window.TossPixel(TOSS_PIXEL_CODE).lead({
        leadType: leadType,
      });
    }
  };

  return trackLead;
};

// Naver 전환추적(방문·상담 전환)은 GTM(GTM-NHKQ5KR6)에서 관리한다.
